import React from 'react';
import {List, Typography, Button} from 'lark';
import {Link} from 'react-router-dom';

const {Title, Paragraph} = Typography;

const LoginHelp = () => (
    <content className="help-content">
        <List>
            <List.Item>
                <Title>问题一：无法登录怎么办？</Title>
                <Paragraph>解答：系统使用与邮箱系统相同的帐号密码，如不能登录系统，请尝试如下解决方法:</Paragraph>
                <Paragraph>1.请登录邮箱系统进行密码修改：mail.baijia.com</Paragraph>
                <Paragraph>2.登录系统后提示无权限，请联系上级主管添加权限</Paragraph>
                <Paragraph>3.如邮箱可正常登录，但系统仍无法登录，请联系各系统产品经理</Paragraph>
                {/*
                <Link to="/cas/reset" className="reset-link">
                    访问【重置密码】
                </Link>
                */}
            </List.Item>
            <List.Item>
                <Title>问题二：账号被禁用怎么办？</Title>
                <Paragraph>解答：若登录提示“账号已被禁用，请联系直属上级，前往高途门户协助申请解封”，请尝试如下解决方法:</Paragraph>
                <Paragraph>
                    第一步：请联系直属上级，请直属上级登录高途门户（
                    <Button type="link" href="https://home.baijia.com/home">
                        https://home.baijia.com/home
                    </Button>
                    ）
                </Paragraph>
                <Paragraph>第二步：点击“流程中心”后，再次点击“发起申请”，选择“IT支持类”-“账号解封”</Paragraph>
                <Paragraph>第三步：按照表单提示填写后，申请通过即可解封账号</Paragraph>
            </List.Item>
        </List>
    </content>
);

export default LoginHelp;
